module.exports = {
  colors: {
    primary: '#8356BE',
    primaryLight: '#9E7BCC',
    primaryDark: '#6C479C',
    secondary: '#00A5C8'
  },
  space: [0, 4, 8, 16, 32, 40, 64, 128, 256, 512],
  fonts: {
    poppins: 'Poppins',
    lato: 'Lato'
  },
  fontWeights: {
    body: 400,
    heading: 700,
    semibold: 600,
    bold: 700,
    black: 900
  },
  lineHeights: {
    body: 1.5,
    heading: 1.25
  },
  shadows: {
    small: '0 0 4px rgba(0, 0, 0, .125)',
    large: '0 0 24px rgba(0, 0, 0, .125)'
  },
  variants: {},
  text: {},
  link: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#8356BE',
    textDecoration: 'none'
  },
  buttons: {
    main: {
      fontFamily: 'lato',
      fontWeight: '600',
      fontSize: '14px',
      letterSpacing: '2px',
      minWidth: '140px',
      borderRadius: '30px',
      padding: '13px 22px',
      cursor: 'pointer',
      outline: 'none',
      '&:hover': {
        backgroundColor: '#9E7BCC'
      },
      '&:active': {
        backgroundColor: '#6C479C'
      },
      transition: '0.3s'
    },
    secondary: {
      color: '#F49999',
      fontFamily: 'Poppins',
      fontWeight: '600',
      fontSize: '13px',
      cursor: 'pointer',
      outline: 'none',
      padding: 'none',
      backgroundColor: 'white',
      '&:hover': {
        color: '#F7B4B4'
      },
      '&:active': {
        color: '#C87E7E'
      },
      transition: '0.3s'
    }
  }
};
